export default __webpack_public_path__ + "static/media/outPatient.ac477204.svg";